import { toast } from 'react-hot-toast';
import { useMutation } from 'react-query';

import {
  GroupSubscriptionConfirmParams,
  confirmGroupSubscription,
} from '@utils/backend-api/groupSubscriptions';

export default function useGroupSubscriptionConfirm() {
  const { mutateAsync, data, isLoading, isError } = useMutation(
    (params: GroupSubscriptionConfirmParams) => confirmGroupSubscription(params),
    {
      onError: () => {
        toast.error(
          'We are unable to confirm your subscription. Please contact support@theinformation.com for assistance.'
        );
      },
    }
  );
  return { mutateAsync, data, isLoading, isError };
}
